import type { NuxtApp } from 'nuxt/app'
import { Capacitor } from '@capacitor/core'
import { CameraApi } from '~/plugins/platform/native/api/camera'
import { FileStorageApi } from '~/plugins/platform/native/api/file-storage'
import { ScannerApi } from '~/plugins/platform/native/api/scanner'
import { PushNotificationsApi } from '~/plugins/platform/native/api/notifications'
import { NfcApi } from '~/plugins/platform/native/api/nfc'

/**
 * Provides a mobile device native API.
 */
export class Native {
  public readonly camera: CameraApi
  public readonly fileStorage: FileStorageApi | undefined = undefined
  public readonly scanner: ScannerApi | undefined = undefined
  public readonly notifications: PushNotificationsApi | undefined = undefined
  public readonly nfc: NfcApi | undefined = undefined

  constructor(app: NuxtApp) {
    this.camera = new CameraApi(app)
    this.notifications = new PushNotificationsApi(app)
    if (!this.isNative) return
    this.fileStorage = new FileStorageApi()
    this.scanner = new ScannerApi(app)
    this.nfc = new NfcApi(app)
  }

  public get isNative() {
    return Capacitor.isNativePlatform()
  }
}
